/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crisp_Equal_Duck_ApproveInputs */

const es_crisp_equal_duck_approve = /** @type {(inputs: Crisp_Equal_Duck_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hace falta que nos creas a nosotros.`)
};

const gl_crisp_equal_duck_approve = /** @type {(inputs: Crisp_Equal_Duck_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non tes que crernos a nós.`)
};

const en_crisp_equal_duck_approve = /** @type {(inputs: Crisp_Equal_Duck_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You don't have to believe us.`)
};

/**
* | output |
* | --- |
* | "You don't have to believe us." |
*
* @param {Crisp_Equal_Duck_ApproveInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const crisp_equal_duck_approve = /** @type {((inputs?: Crisp_Equal_Duck_ApproveInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crisp_Equal_Duck_ApproveInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_crisp_equal_duck_approve(inputs)
	if (locale === "en") return en_crisp_equal_duck_approve(inputs)
	return es_crisp_equal_duck_approve(inputs)
});